export default __webpack_public_path__ + "static/media/music-site.c9daa9bf.svg";